<template>
	<div class='route_container pt-2'>
		<!-- Discussion New -->
		<div class="bg-gradient py-1 px-5 mt-5 hero_section">			
			<div class="hero_section__summary py-1 px-5">
				<h6 class="mb-0"> Discussion > {{ $t('gifts_new_2') }} </h6>
			</div>
		</div>
		<div class="main_container px-5 py-3">
			<div class="row">	
				<div class="col-lg-2"></div>
				<div class="col-lg-8 pl-lg-3 px-0 pb-3">
                    <div class="bg-gray-900 border border-green-lighter mt-3 px-3 d-none">
                        <div class="markdown py-1">
                        	<p>
								<font-awesome-icon icon="check-circle"/> &nbsp;&nbsp;
								<span class="pr-1"></span>
							</p>
                        </div>
                    </div>
					<!-- giveway list -->
					<div @submit.prevent='createDiscussion'>
						<div class="comments border border-green-lighter my-3 px-3">
							<div class="comments">
								<div class="comment">
									<div class="ajax comment__parent">									
										<div class="comment__author">
											<a href="javascript:void(0)">1. {{ $t('gifts_title') }}</a>
										</div>									
									</div>
									<div class="comment__children">
										<div data-comment-id="58216281" class="comment">
											<div class="ajax comment__child">											
												<div class="comment__summary">
													<input 	class="form-control" type="text" 
															placeholder="Type A Title here.."
															v-model="title"
															/>
													<span v-if="error.title" class="text-danger">*{{ $t('gifts_enter_title') }}</span>
												</div>
											</div>										
										</div>
									</div>
								</div>

								<div class="comment">
									<div class="ajax comment__parent">									
										<div class="comment__author">
											<a href="javascript:void(0)">2. Category</a>
										</div>										
									</div>
									<div class="comment__children">
										<div data-comment-id="58216281" class="comment">
											<div class="ajax comment__child">											
												<div class="comment__summary">
													<select class="form-control" v-model="category">
														<option value="">{{ $t('gifts_select_category') }}</option>
                                                        <option v-for="(category, $index) in categories" :value="category.value" :key="$index">
                                                            {{category.name}}
                                                        </option>                                                        
                                                    </select>
													<span v-if="error.category" class="text-danger col-lg-12 pt-1">*{{ $t('gifts_select_category') }}</span>
												</div>
											</div>										
										</div>
									</div>
								</div>

								<div class="comment" :class="`${showPoll}-types`">
									<div class="ajax comment__parent">									
										<div class="comment__author">
											<a href="javascript:void(0)">3. {{ $t('gifts_include_poll') }}</a>
										</div>										
									</div>
									<div class="comment__children">
										<div class="comment">
											<div class="ajax comment__child">											
												<div class="comment__summary">
													<div>
														<label class="redborder">
															<input type="radio" value="true" v-model="showPoll">
															<span class="pl-4">YES</span>
														</label>
													</div>

													<div>
														<label class="redborder">
															<input type="radio" value="false" v-model="showPoll">
															<span class="pl-4">NO</span>
														</label>
													</div>
												</div>
											</div>										
										</div>
									</div>
								</div>

								<div v-if="showPoll" class="comment">									
									<div class="comment__children pb-4">
										<div class='thread_meta_info__poll'>
											<div class='thread_meta_info__poll__top_bar'>
												<fancy-input
													type="text" 
													class="mt-3 thread_meta_info__poll__question"
													placeholder='Poll question'
													v-model='pollQuestion'
													:error='error.pollQuestion'
													:large='true'
												></fancy-input>
												<button 
													class='btn btn-outline-secondary btn-sm'
													@click='removePoll'
													:style="{'border':'1px solid'}"
												>
													{{ $t('gifts_remove_poll') }}
												</button>
											</div>
											<div>
												<div
													class='thread_meta_info__poll__answer'
													:key='"poll-answer-" + $index'
													v-for='(pollAnswer, $index) in pollAnswers'
												>
													<input
														v-model='pollAnswer.answer'
														class="form-control form-thread-title mt-3"
														
														:placeholder='"Answer " + ($index+1)'
													>
													<span @click='removePollAnswer($index)' title='Remove answer'>&times;</span>
												</div>
												<div class='thread_meta_info__form'>
													<fancy-input
														type="text"
														class="form-thread-title mt-3"
														placeholder="Option/answer for poll"
														v-model='newPollAnswer'
														:error='error.pollAnswer'
														:large='true'
													></fancy-input>
													<button class='btn btn-secondary text-nowrap ml-3' 
															@click='addPollAnswer'>{{ $t('gifts_add_answer') }}</button>
												</div>
											</div>
										</div>
									</div>
								</div>

								<div class="comment">
									<div class="ajax comment__parent">									
										<div class="comment__author">
											<a href="javascript:void(0)">4. {{ $t('gifts_description') }} ( {{ $t('gifts_optional')}} )</a>
										</div>										
									</div>
									<div class="comment__children">
										<div data-comment-id="58216281" class="comment">
											<div class="ajax comment__child">											
												<div class="comment__summary">												
													<div>
														<textarea class="form-control" v-model="description"></textarea>
														<span v-if="error.description" class="text-danger">*{{ $t('gifts_enter_description') }}</span>
													</div>												
												</div>
											</div>										
										</div>
									</div>
								</div>

								<div class="row pb-2">									
									<div v-if="error.final" 
										class="text-danger col-12 p-0 mb-1">*{{ $t('gifts_check_all_the_fields') }}</div>									
									<button class="btn btn-primary btn-md rounded" @click="createDiscussion">
										<loading-button
											v-if="creationLoading"
											:loading='creationLoading'
											class='nav-link'
										>
											<font-awesome-icon icon="spinner"/>
										</loading-button>										
										<span v-if="!creationLoading">
											<font-awesome-icon  icon="arrow-right"/>
											<span class="pl-3">{{ $t('gifts_create_discusssion') }}</span>
										</span>
									</button>
								</div>
							</div>
						</div>
					</div>					
				</div>
				<div class="col-lg-2"></div>
			</div>
		</div>
	</div>
</template>

<script>
	import FancyInput from '../FancyInput'
	import InfoTooltip from '../InfoTooltip.vue'
	import LoadingButton from '../LoadingButton';
	import {apiDomain} from '../../config'

	export default {
		name: 'giveaway',
		components: {
			FancyInput,
			InfoTooltip,
			LoadingButton
		},
		data () {
			return {
				whocanenter: 'all',
				selectedDate: null,
				choosed_color: "#00ff7f",
				choosed_back_color: "#00ff7f",
				error:{
					final: false,
					title: false,
					category: false,
					pollQuestion: '',
					pollAnswer: ''
				},
				showPoll: false,
				pollQuestion: '',
				pollAnswer: '',
				newPollAnswer: '',
				pollAnswers: [],
				title: '',
				category: '',
				description: '',
				creationLoading: false,
                categories: [
					{ "name": "All", "value": ""},
					{ "name": "Add-ons / Tools", "value": "addons-tools"}, 
					{ "name": "Announcements", "value": "announcements"},
					{ "name": "Bugs / Suggestions", "value": "bugs-suggestions"},
					{ "name": "Deals", "value": "deals"},
					{ "name": "Game Showcase", "value": "game-showcase"},
					{ "name": "General", "value": "general"},
					{ "name": "Group Recruitment", "value": "group-recruitment"},
					{ "name": "Hardware", "value": "hardware"},
					{ "name": "Help", "value": "help"},
					{ "name": "Let's Play Together", "value": "lets-play-together"},
					{ "name": "Movies / TV", "value": "movies-tv"},
					{ "name": "Off Topic", "value": "off-topic"},
					{ "name": "Puzzles / Events", "value": "puzzles-events"},
					{ "name": "Uncategorized", "value": "uncategorized"},
					{ "name": "User Projects", "value": "user-projects"},
					{ "name": "Whitelist Recruitment", "value": "whitelist-recruitment"}
				],
			}
		},
		methods:{
			hasDuplicates (array, cb) {
				if(cb) array = array.map(cb)
				
				return array.length !== (new Set(array)).size
			},
			createDiscussion: function(){	
				if(!this.title.length){ this.error.title = true; return;} 
				if(!this.category.length){ this.error.category = true; return;} 

				if(this.showPoll && !this.pollQuestion.trim().length) {
					this.error.pollQuestion = `${ $t('gifts_cannot_blank') }`; return;
				}				 
				if(this.showPoll && this.pollAnswers.length < 2) {
					this.error.pollAnswer = `${ $t('gifts_2_answers') }`; return;
				}				 
				if(this.showPoll && this.hasDuplicates(this.pollAnswers, i => i.answer)) {
					this.error.pollAnswer = `${ $t('gifts_no_duplicated') }`; return;
				}
				
				if(!this.description.length){ this.error.description = true; return;} 

				let pollData = this.showPoll ? {question: this.pollQuestion, answers : this.pollAnswers.map(a => a.answer) } : null;

				let data = {	title: this.title,
								category: this.category, 
								description: this.description,
								poll: { poll: this.showPoll, data: pollData }
							}
				
				this.creationLoading = true;
				
				this.axios.request({
					method: 'post',
					url: `${apiDomain}/api/v1/discussion`,
					data: data,
					headers: {
						'Authorization': `Bearer ${this.$cookies.get('authtoken')}`
					}
				}).then(res => {
					this.creationLoading = false;
					this.$store.commit('setDiscussions', res.data.content);

					this.$router.push(`/${this.$store.state.meta.lang}/discussions`)

				}).catch(err => {
					
					this.creationLoading = false;						
					console.log(err)
				})
			},
			togglePoll (val) {
				if(val !== undefined) {
					this.showPoll = val
				} else {
					this.showPoll = !this.showPoll
				}
			},
			addPollAnswer () {
				if(!this.newPollAnswer.trim().length) return

				this.pollAnswers.push({ answer: this.newPollAnswer })
				this.newPollAnswer = ''
			},
			removePollAnswer ($index) {
				this.pollAnswers.splice($index, 1)
			},
			removePoll () {
				this.pollQuestion = ''
				this.pollAnswers = []
				this.newPollAnswer = ''

				this.togglePoll()
			},
		},
		watch: {			
		},
	}
</script>

<style lang='scss' scoped>
	@import '../../assets/scss/elementStyles.scss';
	@import '../../assets/scss/variables.scss';
	@import '../../assets/scss/idec.scss';

	.thread_new {
		margin-top: 1rem;
	}

	.thread_meta_info {
		background-color: #fff;
		border: thin solid $color__gray--darker;
		border-radius: 0.25rem;
		padding: 1rem;
		margin: 1rem 0;

		@at-root #{&}__title {
			margin: 0 0.5rem;
			display: inline-block;
		}

		@at-root #{&}__form {
			display: flex;
			align-items: baseline;
		}

		@at-root #{&}__add_poll {
			margin-top: 0.5rem;
		}

		@at-root #{&}__text {
			margin-bottom: 0.5rem;
		}

		@at-root #{&}__poll {
			border-top: thin solid $color__gray--primary;
			margin-top: 1rem;
			padding-top: 0.75rem;
			position: relative;

			@at-root #{&}__top_bar {
				display: flex;
				justify-content: space-between;
				align-items: baseline;
				max-width: 850px;
			}

			@at-root #{&}__answer {
				display: flex;
				align-items: baseline;

				& > span {
					opacity: 0;
					pointer-events: none;
					transition: all 0.1s;

					font-size: 1.5rem;
					margin-left: 0.5rem;
					cursor: pointer;
					@include user-select(none);
				}

				&:hover > span {
					opacity: 1;
					pointer-events: all;
				}
			}
		}
	}

	.hero_section{
		display: flex;
		justify-content: center; 
		align-items: center;

		@at-root #{&}__img_link {
			margin-right: 25px;
			background-color: rgba(0,0,0,0.2);
			border-left-color: transparent;
			border-top-color: transparent;
			box-shadow: 3px 3px 4px #0000002e;
			padding: 10px;

			img{
				width: 100%;
				max-width: 500px;
				max-height: 215px;
			}
		}

		@at-root #{&}__summary {
			flex: 1;

			.summary_columns{
				display: flex;

				.summary__column{
					min-height: 26px;
					white-space: nowrap;
					color: rgba(255,255,255,0.6);
					border-radius: 4px;
					font-size: 11px;
					border: 1px solid rgba(255,255,255,0.1);
					line-height: 26px;
					padding: 0 8px;

					&:nth-child(2){
						flex: 1;
						margin-left: 0.5rem;
						margin-right: 0.5rem;
					}
				}

                .giveaway__columns{
                    &__contributor-level{
                        border-color: #f0d0d3 #e5bbbc #daa9a8 #ebbfc0 !important;
                        color: rgba(166,93,92,0.95) !important;
                        background-image: -webkit-linear-gradient(#f5eaec 0%, #e6d9de 100%) !important;
                        white-space: nowrap;
                        border-radius: 4px;
                        font-size: 11px;
                        border: 1px solid #d2d6e0;
                        line-height: 30px;
                        padding: 0 8px;
                        margin-right: 0.5rem;
                    }
                }
			}
		}
	}

    .markdown_description p{
        margin-bottom: 1rem;
    }

	.router-link-exact-active span:first-child {
		background-color: $color__green--primary;
	}

	.router-link-exact-active span:last-child {
		color: $color__green--primary;
	}

    .comments{
		.comment{
			margin: 1rem 0;
			border-bottom: 1px solid $color__gray--darker;

			&:last-child{
				border-bottom: none;
			}

			&__parent, &__child, &__entity{
				max-width: 850px;
				display: flex;
			}

			&__children{
				margin-left: 50px;
			}

			.global__image-outer-wrap--avatar-small{
				height: 32px;
				width: 32px;
			}

			&__child{
				border: 1px solid $color__lightgray--primary;
				border-radius: 4px;
				padding: 15px;
			}

			&__actions{
				display: flex;
			}

			.global__image-outer-wrap--avatar-small{
				margin-right: 10px;
			}

			&__children:not(.comment__children--no-indent){
				padding-left: 25px;
				border-left: 1px solid #d2d6e0;
			}

			.giveaway_image_avatar{
				margin-right: 1rem;
			}

			&__summary{
                padding-bottom: 0.5rem;

				.comment__author{
					color: $color__green--primary;
					margin-bottom: 5px;
					display: flex;

					svg{
						margin-top: -1px;
						margin-right: 0.5rem;

						&:focus, &:hover{
							cursor: pointer;
							outline: none;
						}
					}
				}
			}
			.nav__avatar-inner-wrap, .global__image-inner-wrap{
				background-position: center center;
				background-repeat: no-repeat;
				background-size: cover;
				height: 100%;
				width: 100%;
				border-radius: 2px;
			}
		}
	}

    .collapsed > .when-opened,
    :not(.collapsed) > .when-closed {
        display: none;
    }
	.redborder{ cursor: pointer;}
	.tredborder{ cursor: pointer;}
    .true-types{ border-bottom: none!important;}
	@media (max-width: $breakpoint--tablet) {
		.hero_section{
			display: block;
			text-align: center;
		}
	}
</style>
